export default function filterHiddenCategories(category) {
   return category?.name !== 'Intelligent Design Content';
}
